module.exports = __webpack_public_path__ + "static/img/ent-58.3e0ca2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-58.jpg
// module id = bPxr
// module chunks = 51